import { cn } from "@/lib/utils";

const STATUS_MAP = {
  green: { bg: "bg-emerald-50", text: "text-emerald-700", ring: "ring-emerald-600/20", label: "On Track" },
  amber: { bg: "bg-amber-50", text: "text-amber-700", ring: "ring-amber-600/20", label: "At Risk" },
  red: { bg: "bg-red-50", text: "text-red-700", ring: "ring-red-600/20", label: "Delayed" },
  scheduled: { bg: "bg-zinc-100", text: "text-zinc-700", ring: "ring-zinc-500/20", label: "Scheduled" },
  in_progress: { bg: "bg-blue-50", text: "text-blue-700", ring: "ring-blue-600/20", label: "In Progress" },
  at_risk: { bg: "bg-amber-50", text: "text-amber-700", ring: "ring-amber-600/20", label: "At Risk" },
  delayed: { bg: "bg-red-50", text: "text-red-700", ring: "ring-red-600/20", label: "Delayed" },
  completed: { bg: "bg-emerald-50", text: "text-emerald-700", ring: "ring-emerald-600/20", label: "Completed" },
};

export function StatusPill({ status, className, children, testId }) {
  const cfg = STATUS_MAP[status] || STATUS_MAP.scheduled;
  return (
    <span
      data-testid={testId || `status-pill-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
        cfg.bg,
        cfg.text,
        cfg.ring,
        className,
      )}
    >
      <span className={cn("inline-block h-1.5 w-1.5 rounded-full",
        status === "green" || status === "completed" ? "bg-emerald-500" :
        status === "amber" || status === "at_risk" ? "bg-amber-500" :
        status === "red" || status === "delayed" ? "bg-red-500" :
        status === "in_progress" ? "bg-blue-500" : "bg-zinc-400")} />
      {children || cfg.label}
    </span>
  );
}

export default StatusPill;
